import React, { useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { RiAccountBoxLine, RiMoneyDollarCircleLine } from 'react-icons/ri';
import { FiFileText } from 'react-icons/fi';
import { BiTransfer } from 'react-icons/bi';
import { MdOutlinePayments } from 'react-icons/md';
import { GiReceiveMoney } from 'react-icons/gi';
import { VscHome } from 'react-icons/vsc';
import { MdList } from 'react-icons/md';
import { GoFile } from 'react-icons/go';
export default function ListItemSidebar(props) {
  const { classes } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState('/dashboard');

  useEffect(() => {
    setSelectedTab(location.pathname);
  }, [location]);

  return (
    <List>
      <ListItem
        selected={selectedTab === '/dashboard' || selectedTab === '/'}
        button
        onClick={() => navigate('/dashboard')}
        key={0}
      >
        <ListItemIcon className={classes.icons}>
          <VscHome />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/perfis'}
        button
        onClick={() => navigate('/perfis')}
        key={3}
      >
        <ListItemIcon className={classes.icons}>
          <RiAccountBoxLine />
        </ListItemIcon>
        <ListItemText primary="Perfis" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/gerenciar-clientes'}
        button
        onClick={() => navigate('/gerenciar-clientes')}
        key={1}
      >
        <ListItemIcon className={classes.icons}>
          <HiOutlineUserGroup />
        </ListItemIcon>
        <ListItemText primary="Gerenciar Clientes" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/logs'}
        button
        onClick={() => navigate('/logs')}
        key={5}
      >
        <ListItemIcon className={classes.icons}>
          <MdList />
        </ListItemIcon>
        <ListItemText primary="Logs" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/pagamentos'}
        button
        onClick={() => navigate('/pagamentos')}
        key={2}
      >
        <ListItemIcon className={classes.icons}>
          <MdOutlinePayments />
        </ListItemIcon>
        <ListItemText primary="Pagamentos" />
      </ListItem>

      <ListItem
        selected={selectedTab === '/boletos'}
        button
        onClick={() => navigate('/boletos')}
        key={4}
      >
        <ListItemIcon className={classes.icons}>
          <FiFileText />
        </ListItemIcon>
        <ListItemText primary="Transação de Boletos" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/transferencias'}
        button
        onClick={() => navigate('/transferencias')}
        key={7}
      >
        <ListItemIcon className={classes.icons}>
          <BiTransfer />
        </ListItemIcon>
        <ListItemText primary="Transferências" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/servicosDigitais'}
        button
        onClick={() => navigate('/servicosDigitais')}
        key={8}
      >
        <ListItemIcon className={classes.icons}>
          <GiReceiveMoney />
        </ListItemIcon>
        <ListItemText primary="Serviços Digitais" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/emprestimo'}
        button
        onClick={() => navigate('/emprestimo')}
        key={6}
      >
        <ListItemIcon className={classes.icons}>
          <RiMoneyDollarCircleLine />
        </ListItemIcon>
        <ListItemText primary="Empréstimos" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/relatorios'}
        button
        onClick={() => navigate('/relatorios')}
        key={10}
      >
        <ListItemIcon className={classes.icons}>
          <GoFile />
        </ListItemIcon>
        <ListItemText primary="Relatórios" />
      </ListItem>
      <ListItem
        selected={selectedTab === '/relatorio-comissao'}
        button
        onClick={() => navigate('/relatorio-comissao')}
        key={10}
      >
        <ListItemIcon className={classes.icons}>
          <GoFile />
        </ListItemIcon>
        <ListItemText primary="Relatório de Comissão" />
      </ListItem>
    </List>
  );
}

ListItemSidebar.propTypes = {
  text: PropTypes.string,
  index: PropTypes.number,
  classes: PropTypes.object,
};
